<div class="row">
    <div class="col-md-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons></yt-fw-default-update-buttons>
    </div>
</div>
<!--<yt-fak-dokument-update #baseUpdate></yt-fak-dokument-update>-->
<yt-resenje-za-go-update #baseUpdate></yt-resenje-za-go-update> 